import styled from 'styled-components';
import { StyledLink } from '../CategoryLink/CategoryLink.styles';
import media from '../../styles/config/mediaQueries';

const StyledContainer = styled.section`
  > .swiper .swiper-slide {
    width: 100%;
    max-width: 139px;
  }

  ${StyledLink} {
    margin-bottom: 16px;
  }
  ${media.mobile`
    margin-bottom: 27px;
  `}
  ${media.desktop`
    position: relative;
    margin-bottom: 20px;
  `}
`;

const StyledButton = styled.button`
  display: inline-block;
  width: 100%;
`;

const StyledImage = styled.img`
  width: 100%;
  object-fit: cover;
  border-radius: 10px;
  ${media.mobile`
    height: 201px;
  `}
  ${media.desktop`
    height: 215px;
  `}
`;

const StyledPrevButton = styled.button`
  position: absolute;
  top: calc(50% + 11px);
  left: -12px;
  transform: translateY(-50%);
  width: 26px;
  height: 26px;
  z-index: 2;
`;

const StyledNextButton = styled.button`
  position: absolute;
  top: calc(50% + 11px);
  right: -12px;
  transform: translateY(-50%);
  width: 26px;
  height: 26px;
  z-index: 2;
`;

export { StyledContainer, StyledButton, StyledImage, StyledPrevButton, StyledNextButton };
